import React, { useState } from 'react';
import { Button, Textarea } from '../../ui';

/**
 * Branch Notes Component
 * Displays and allows adding notes for a branch
 */
const BranchNotes = ({
  notes,
  onAddNote,
  isLoading = false,
}) => {
  const [noteText, setNoteText] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async () => {
    if (!noteText.trim()) return;
    
    setIsSubmitting(true);
    try {
      await onAddNote(noteText);
      setNoteText('');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="mt-8 bg-slate-800 rounded-lg p-4 md:p-6 shadow-md border border-slate-700">
      <h3 className="mb-4 text-lg font-semibold text-white">Branch Notes</h3>
      
      <div className="mb-4">
        <Textarea
          value={noteText}
          onChange={(e) => setNoteText(e.target.value)}
          placeholder="Add a note..."
          rows={2}
          containerClassName="mb-2"
        />
        <Button
          onClick={handleSubmit}
          loading={isSubmitting}
          disabled={!noteText.trim()}
        >
          Add Note
        </Button>
      </div>

      <ul className="space-y-2">
        {notes.map((note) => (
          <li
            key={note.id}
            className="border-b border-slate-700 pb-2 text-sm text-slate-300"
          >
            {note.note}
            <span className="text-slate-400 ml-2">
              – {note.author?.name || ''}, {new Date(note.createdAt).toLocaleString()}
            </span>
          </li>
        ))}
        {notes.length === 0 && !isLoading && (
          <li className="text-slate-400">No notes yet.</li>
        )}
      </ul>
    </div>
  );
};

export default BranchNotes;

